var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel"},[_c('el-carousel',{attrs:{"trigger":"click","height":"470px"}},_vm._l((_vm.list),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{attrs:{"src":_vm.imgURL+item.image}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }